import CloseIcon from '@mui/icons-material/Close'
import DoneIcon from '@mui/icons-material/Done'
import { Box, Switch, SwitchProps, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  switchBase: {
    color: theme.palette.error.light,
    '&$checked': {
      color: theme.palette.success.light,
      '& + $track': {
        backgroundColor: theme.palette.success.light,
      },
    },
  },
  track: {
    backgroundColor: theme.palette.error.light,
  },
  checked: {},
  disabled: {
    filter: 'saturate(0%)',
  },
}))

export const ColoredSwitch: React.FC<SwitchProps> = props => {
  const classes = useStyles()
  return (
    <Box display="flex" alignItems="center">
      <Switch
        {...props}
        classes={{
          switchBase: classes.switchBase,
          track: classes.track,
          checked: classes.checked,
          disabled: classes.disabled,
        }}
        checkedIcon={
          <DoneIcon
            sx={t => ({
              color: t.palette.common.white,
              fontSize: 20,
              padding: t.spacing(1),
              borderRadius: 20,
              backgroundColor: t.palette.success.light,
            })}
          />
        }
        icon={
          <CloseIcon
            sx={t => ({
              color: t.palette.common.white,
              fontSize: 20,
              padding: t.spacing(1),
              borderRadius: 20,
              backgroundColor: t.palette.error.light,
            })}
          />
        }
      />
    </Box>
  )
}
